import Model from "@/models/Model";
import Asset from "@/models/Asset";

export default class Artifact extends Model {
  name: string;
  code: string;
  asset?: Asset;
}
